import { IconTimeArrow } from "@suse-o11y/icons";
import React from "react";

import type { SpecificRange, TimeRange } from "../../../../../app/state/view/timeline/TimeRange";

export interface TimeRangeSelectorContentButtonProps {
	selected: undefined | boolean;
	timeRange: TimeRange;
	onClick: VoidFunction;
}

export const TimeRangeSelectorContentButton: React.FC<TimeRangeSelectorContentButtonProps> = ({
	selected,
	timeRange,
	onClick,
}) => (
	<button
		aria-selected={selected}
		className="block h-4 border border-none p-0 hocus:text-primary-600 text-13 text-grey-800 leading-4 shadow-none transition-colors aria-selected:font-medium aria-selected:text-primary-600"
		onClick={() => {
			if (!selected) {
				onClick();
			}
		}}
		type="button"
	>
		{timeRange.isSpecific() ? <SpecificRangeLabel timeRange={timeRange} /> : timeRange.toUserFriendlyString()}
	</button>
);

const SpecificRangeLabel: React.FC<{
	timeRange: SpecificRange;
}> = ({ timeRange }) => {
	const [start, end] = timeRange.toUserFriendlyString().split("-");

	return (
		<div className="flex gap-1">
			{start}
			<IconTimeArrow className="text-grey-500" />
			{end}
		</div>
	);
};
